export default __webpack_public_path__ + "static/import-designs-panel-3a004edbfdd0bbb68982e8a285290ef2.png";